export default "__VITE_ASSET__BVTYpfsY__"